module.exports = __webpack_public_path__ + "fire.965fefb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/fire.png
// module id = 1525
// module chunks = 0